/** Status contrForn usados nos fluxos de aprovação / assinatura. */
export const CONTR_FORN_STATUS_ATIVO = 2;
export const CONTR_FORN_STATUS_EM_ASSINATURA = 7;
export const CONTR_FORN_STATUS_EM_APROVACAO = 8;

/** Valor mínimo (R$) para exigir task de aprovação de contrato. */
export const CONTR_FORN_APROVACAO_MIN_VLR = 10000;

/** Alias legado (cotação rápida) — mesmo limiar unificado. */
export const CONTR_FORN_RAPIDA_APROVACAO_MIN_VLR = CONTR_FORN_APROVACAO_MIN_VLR;

/** Marcador em compraCotacao_info: Criar contrato direto (sem e-mail ao fornecedor). */
export const FLUXO_CONTRATACAO_CRIAR_DIRETO = 'criar_contrato_direto';

export const needsContrFornApproval = (vlr) => (
  (Number(vlr) || 0) >= CONTR_FORN_APROVACAO_MIN_VLR
);

const parseCompraCotacaoInfoObject = (raw) => {
  if (raw == null || raw === '') return {};
  if (typeof raw === 'object' && !Array.isArray(raw)) return { ...raw };
  try {
    const parsed = JSON.parse(String(raw));
    return (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) ? parsed : {};
  } catch (e) {
    return {};
  }
};

/** Monta compraCotacao_info marcando fluxo "Criar contrato" (pós-aprovação → Em assinatura, sem e-mail). */
export const buildCriarContratoDiretoCompraCotacaoInfo = (existingInfo = null) => (
  JSON.stringify({
    ...parseCompraCotacaoInfoObject(existingInfo),
    fluxo_contratacao: FLUXO_CONTRATACAO_CRIAR_DIRETO,
  })
);

export const isCriarContratoDiretoCompraCotacao = (compraCotacao = {}) => (
  parseCompraCotacaoInfoObject(compraCotacao?.compraCotacao_info).fluxo_contratacao
    === FLUXO_CONTRATACAO_CRIAR_DIRETO
);

/**
 * Status após decisão de aprovação por valor.
 * @param {'rapidaSemFornecedor'|'validacao'|'criarContrato'} fluxo
 */
export const resolveContrFornStatusAfterValueGate = (vlr, fluxo = 'validacao') => {
  if (needsContrFornApproval(vlr)) {
    return CONTR_FORN_STATUS_EM_APROVACAO;
  }
  if (fluxo === 'rapidaSemFornecedor') {
    return CONTR_FORN_STATUS_ATIVO;
  }
  // validacao / criarContrato / reenviar sem aprovação: Em assinatura
  return CONTR_FORN_STATUS_EM_ASSINATURA;
};
